import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
    // Url of the Identity Provider
    issuer:'',// 'https://localhost:44350',

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + '/callback',

  // URL of the SPA to redirect the user after silent refresh
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',

  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId:'',// '05c9423e-f377-475c-a01a-42274bc6e22d',
  
  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: 'openid profile ',

  //silentRefreshShowIFrame: true,
  showDebugInformation: false,

  postLogoutRedirectUri: window.location.origin,

  sessionChecksEnabled: false,

  silentRefreshTimeout: 20000
};
